import { formatHourNumber, formatTimestamp } from '@/helpers';
import { CampaignsType } from '@/types';
import { Flex, Typography } from '@alpine-iq/ui-library';
import React from 'react';

export default function CampaignScheduledCell({ campaign }: { campaign: CampaignsType }) {
	const { blast, scheduled, recurDays, dateRange, sendWindow } = campaign;

	if (blast) {
		return (
			<Flex column>
				<Typography>Blast</Typography>
				<Typography variant="body-sm">Start: {formatTimestamp(scheduled)}</Typography>
			</Flex>
		);
	}

	const hasRecurrence = recurDays !== -1 && recurDays;
	const recurrenceDescription = hasRecurrence ? `(Recurs every ${recurDays} days)` : '';

	const hasSendWindow = sendWindow?.start && sendWindow?.end;
	const windowStr = hasSendWindow ? `Send window: ${formatHourNumber(sendWindow.start)}-${formatHourNumber(sendWindow.end)}` : '';

	if (scheduled) {
		return (
			<Flex column>
				<Typography>Ongoing</Typography>
				<Typography variant="body-sm">Start: {formatTimestamp(scheduled)}</Typography>
				{recurrenceDescription && <Typography variant="body-sm">{recurrenceDescription}</Typography>}
				{windowStr && <Typography variant="body-sm">{windowStr}</Typography>}
			</Flex>
		);
	}

	const isDateRange = dateRange?.active;

	return (
		<Flex column>
			<Typography>Ongoing</Typography>
			{isDateRange && (
				<>
					<Typography variant="body-sm">Start: {formatTimestamp(dateRange.start)}</Typography>
					<Typography variant="body-sm">End: {formatTimestamp(dateRange.end)}</Typography>
				</>
			)}
		</Flex>
	);
}
